import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { KieneBooleanTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { Tierart } from './tierart';
import { TierartDialogComponent } from './tierart-dialog/tierart-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-tierarten',
    templateUrl: './tierarten.component.html',
    styleUrls: ['./tierarten.component.scss'],
})
export class TierartenComponent implements OnInit {
    tableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private readonly api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Tierarten';
        this.tableDescriptor.uniqueIdentifier = 'Tierarten';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'tierart/';
        this.tableDescriptor.standardCreate = false; // nur phito legt Tierarten an

        const columns: TableColumn[] = [];

        columns.push(new TableColumn('bezeichnung', 'Tierart'));
        columns.push(new TableColumn('kuerzel', 'Kürzel'));
        columns.push(new KieneBooleanTableColumn('mnp_rind', 'MNP Rind'));
        columns.push(new KieneBooleanTableColumn('ueber_8_monate', '> 8 Monate'));
        columns.push(new KieneBooleanTableColumn('mnp_schwein', 'MNP Schwein'));
        columns.push(new KieneBooleanTableColumn('ueber_30_kg', '> 30 KG'));
        columns.push(new KieneBooleanTableColumn('hit', 'HIT'));
        columns.push(new KieneBooleanTableColumn('qs', 'QS'));

        this.tableDescriptor.columns = columns;

        this.tableDescriptor.initialSortColumn = 'tierart';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.defaultPageSize = 10;

        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.options.push(
            new TableOption(this.openTierartDialog.bind(this), 'Bearbeiten', 'edit', 2023),
        );
        this.tableDescriptor.options.push(new TableOption(this.openDeleteDialog.bind(this), 'Löschen', 'delete', 2024));
    }

    openTierartDialog(tierart?: Tierart) {
        const dialogRef = this.dialog.open(TierartDialogComponent, { width: '500px', data: { tierart: tierart } });

        dialogRef.afterClosed().subscribe(() => {
            this.api.reload();
        });
    }

    openDeleteDialog(tierart: Tierart) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: {
                title: tierart.tierart + ' löschen?',
                text: 'Wollen Sie die Tierart ' + tierart.bezeichnung + ' wirklich löschen?',
            },
        });

        dialogRef.afterClosed().subscribe(
            response => {
                if (response) {
                    this.api.deleteEntity(this.apiBaseUrl + 'tierart/delete.php', tierart).subscribe(
                        () => {
                            this.messageService.infoMessage('Die Tierart wurde erfolgreich gelöscht!');
                            this.api.reload();
                        },
                        error => {
                            this.messageService.errorMessage(
                                'Fehler! Es ein Problem beim Löschen der Tierart aufgetreten! ',
                                error,
                            );
                        },
                    );
                }
            },
            () => {},
        );
    }
}
